import React, { Component } from 'react';
import { connect } from 'react-redux';
import style from './style.css';
import CSSModule from 'react-css-modules';
import { Link } from 'react-router';
import $ from 'jquery';


import ClassAD from '../../component/classAD';
import Title from '../../component/title';

class ApplyExp extends Component {
    componentDidMount() {
        
    }
    render() {
        const { normal, activity } = this.props;
        return (
            <div>
                { activity && activity.length > 0 && <div>
                    <Title>活動報名</Title>
                    <div styleName="container">
                        { activity && activity.map((object, index) => {
                            return <Link to={`/class/${object.id}`} query={object}><ClassAD { ...object } styleName="block"/></Link>
                        })}
                    </div>
                </div> }
                <Title>報名課程單堂課</Title>
                <div styleName="container">
                    { normal && normal.map((object, index) => {
                        return <Link to={`/class/${object.id}`} query={object}><ClassAD { ...object } styleName="block"/></Link>
                    })}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
	return {
        normal: state.data.classPool.normal,
        activity: state.data.classPool.activity
    };
}

export default connect(mapStateToProps, { })(CSSModule(ApplyExp,style,{allowMultiple:true}));


/** WEBPACK FOOTER **
 ** ./src/container/applyExp/index.js
 **/